document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('photo-toggle-input');
  if (!toggle) return;

  const saved = localStorage.getItem('jd_photo_mode'); // 'flatlay' oder 'shooting'
  const mode = saved || 'flatlay';

  if (mode === 'shooting') {
    document.body.classList.add('show-shooting');
    toggle.checked = false;
  } else {
    document.body.classList.remove('show-shooting');
    toggle.checked = true;
  }

  toggle.addEventListener('change', function () {
    const newMode = this.checked ? 'flatlay' : 'shooting';
    document.body.classList.toggle('show-shooting', newMode === 'shooting');
    localStorage.setItem('jd_photo_mode', newMode);
  });
});